import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { ProfileContext } from 'context';
import { useAction } from 'hooks';
import App from 'modules/App';
import Hcp from 'modules/Hcp';
import Visit, { VisitNotes } from 'modules/Visit';
import styles from '../Results/Results.pcss';
const HcpVisitNotes = ()=>{
    const profileContext = useContext(ProfileContext);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const notes = useSelector(profileContext.selectors.notes);
    const activePatient = useSelector(Hcp.selectors.activePatient);
    const activeVisit = useSelector(Visit.selectors.activeVisit);
    const phiSetDocumentId = useSelector(Hcp.selectors.phiSetDocumentId);
    const sharingRequest = useSelector(Hcp.selectors.sharingRequest);
    const visitNotesFloatingModal = useSelector(App.selectors.floatingModalSelector(Visit.constants.VISIT_NOTES_FM));
    const onStoreAndPushNotes = useAction(Hcp.actions.storeAndPushNote);
    return /*#__PURE__*/ _jsx("div", {
        className: cn('col-auto', styles.col, styles.notesContainer, {
            [styles['notesContainer--activeVisit']]: activeVisit,
            [styles['notesContainer--hidden']]: !visitNotesFloatingModal
        }),
        children: /*#__PURE__*/ _jsx("div", {
            className: cn('widgets pr-0', {
                'p-0': activeVisit
            }),
            children: /*#__PURE__*/ _jsx(VisitNotes, {
                // TODO get rid props drilling use ProfileContext instead in hooks version of comp below
                activePatient: activePatient,
                phiSetDocumentId: phiSetDocumentId,
                phiSet: phiSet,
                notes: notes,
                sharingRequest: sharingRequest,
                successAction: Hcp.actions.setNotes,
                onStoreNotes: onStoreAndPushNotes
            })
        })
    });
};
export default HcpVisitNotes;
